import router from "../router/index";
import { httpGet } from "../services/apiService";

export const destiniesModule = {
    state: () => ({
        allStates: [],
        allDestinies: [],
        filteredDestinies: [],
        selectedState: null,
        selectedDestiny: null,
    }),
    mutations: {
        setAllStates(state, newValue) {
            state.allStates = newValue;
        },
        setAllDestinies(state, newValue) {
            state.allDestinies = newValue;
        },
        setFilteredDestinies(state, newValue) {
            state.filteredDestinies = newValue;
        },
        setSelectedState(state, newValue) {
            state.selectedState = newValue;
        },
        setSelectedDestiny(state, newValue) {
            state.selectedDestiny = newValue;
        },
    },
    actions: {
        async getDestinies({ state, commit }) {
            const { data: locationData } = await httpGet("/destinos");
            let processed = [];
            let states = [];
            for (const l of locationData?.data) {
                const match = states.filter(s => s == l.attributes.estado);
                if (match.length == 0) {
                    states.push(l.attributes.estado);
                }

                const opt = {
                    text: `${l?.attributes?.destino}`,
                    value: l
                }
                processed.push(opt);
            }
            commit('setAllStates', states);
            commit('setAllDestinies', processed);
        },
        changeSelectedState({ state, commit, dispatch }, item) {
            (item);
            commit("setSelectedState", item);
            const filtered = state.allDestinies.filter(d => d.value.attributes.estado == state.selectedState);
            commit("setFilteredDestinies", filtered);
            (state.filteredDestinies);
            commit("setSelectedDestiny", null);
        }
    }
}